import React, { Component } from 'react';
import Default from './default';
import Contact from './components/contact';
import Nav from './components/nav';

class Index extends Component {
  render() {
    const { blocks, credentials } = this.props;
    return (
      <Default {...this.props}>
        { blocks.map(block => {
          const hasBackgroundImage = !!(block.backgroundImage && block.backgroundImage.secure_url);
          const hasImage = !!(block.image && block.image.secure_url);
          return (
            <section
              id={block._id}
              data-magellan-target={block._id}
              style={hasBackgroundImage ? {backgroundImage: `url(${block.backgroundImage.secure_url})`} : {}}
              key={block._id}
              className={block.style}
            >
              <div className="wrapper">
                <div className="column row">
                  <article className="content">
                    { hasImage &&
                      <img src={block.image.secure_url} alt={block.title} />
                    }
                    <h1>{block.title}</h1>
                    <div dangerouslySetInnerHTML={{ __html: block.content }} />
                  </article>
                </div>
              </div>
            </section>
          );
        })}

        <Contact credentials={credentials} />
        <Nav
          items={blocks.map(block => {
            return {
              title: block.title,
              slug: block._id,
            };
          })}
        />
      </Default>
    );
  }
};

// NEEDS TO BE EXPORTS!!
module.exports = Index;



// WEBPACK FOOTER //
// ./templates/views/index.jsx